import { render, staticRenderFns } from "./workShopInfo.vue?vue&type=template&id=09d36808"
import script from "./workShopInfo.vue?vue&type=script&lang=js"
export * from "./workShopInfo.vue?vue&type=script&lang=js"
import style0 from "./workShopInfo.vue?vue&type=style&index=0&id=09d36808&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports